var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../layout.njk"] = require( "../layout.njk" );




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/pages/styleguide.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../layout.njk", true, "src/views/pages/styleguide.njk", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("body_class"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_body_class(env, context, frame, runtime, cb) {
var lineno = 2;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "styleguide";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 4;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n  <main class=\"\">\r\n    <section class=\"section\">\r\n      <div class=\"container\">\r\n        <h1>Style Guide</h1>\r\n        <h2>Sub header</h2>\r\n        <p>This page contains all the front-end components that will be used in the Suboxone Consumer website.</p>\r\n        <p>Refer to the following sections below to see how to implement common components to avoid having to re-write code.</p>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-login-dea-error\">Modal Login - DEA error</button><br/><br/>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-login-npi-error\">Modal Login - NPI error</button><Br/><br/>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-login-all-error\">Modal Login - all error</button><Br/><br/>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-login-email-error\">Modal Login - Email error</button><Br/><br/>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-login-email-error2\">Modal Login - Email error2</button><Br/><br/>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-login-verification-sent\">Modal Login - Verification sent</button><Br/><br/>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-logout\">Modal Log out</button><Br/><br/>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-delete-listings\">Modal Delete Listings</button><Br/><br/>\r\n\r\n        <button class=\"btn\" data-component=\"modal\" data-target=\"modal-unsaved-changes\">Modal Unsaved Changes</button><Br/><br/>\r\n\r\n        <p class='svg-pending'>\r\n          <svg class=\"svg--icon-pending\">\r\n              <use xlink:href=\"#icon-pending\"></use>\r\n          </svg>\r\n          PENDING ADD\r\n        </p>\r\n      </div>\r\n    </section>\r\n  </main>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_body_class: b_body_class,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/pages/styleguide.njk"] , dependencies)